import { render, staticRenderFns } from "./ProviderPlanSection.vue?vue&type=template&id=18e0db64&scoped=true"
import script from "./ProviderPlanSection.vue?vue&type=script&lang=js"
export * from "./ProviderPlanSection.vue?vue&type=script&lang=js"
import style0 from "./ProviderPlanSection.vue?vue&type=style&index=0&id=18e0db64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e0db64",
  null
  
)

export default component.exports